import React, { Fragment, useEffect, useState } from 'react';
import { Row, Label, Alert, Input, } from 'reactstrap';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import '../estilos.css';
import { Bar, Line, Pie } from 'react-chartjs-2';


function Graficapietabla({
    encabezado, //Encabezado de la sección
    encabezadoTabla, //Array con los encabezados de la tabla ["Encabezado1", "Encabezado2", ...]
    datosTabla, //Array de objetos con los datos de la tabla [{Encabezado1: "dato1", Encabezado2: "dato2"}, ...]
    datosgraficapie, //Objeto con los datos de la gráfica pie {label: ["label1", "label2"], data: [{data: [10, 20], backgroundColor: ["#FF6384", "#36A2EB"]}]}, borderColor: ["#FF6384", "#36A2EB"]}, borderWidth: 1}
    Piedetabla, //Texto que se muestra al final de la tabla
    tablaizquierda,//Si el valor es true, la tabla se muestra a la izquierda de la gráfica, si es false, se muestra a la derecha
    tablaTipo, //se espera texto indicando el tipo de tabla para mostrar especificaciones dependiento del tipo de tabla, ejemplo SeguimientoPintado
}) {

    const opciones = {
        responsive: true,
        maintainAspectRatio: false, // Permite ajustar el tamaño manualmente
    };

    //Declaración de variables        
    return (
        <Fragment>
            {(datosTabla && datosgraficapie && encabezado) && (
                <Row>

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop10px" >
                        <h5 className=" ">{encabezado}</h5>
                    </div>
                    {/* Tabla a la derecha o izquierda de la gráfica */
                        tablaizquierda === true && (
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 margintop20px" >
                                <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                                    {tablaTipo === "SeguimientoPintado" && (
                                        <>
                                            <Label className="floatleft ml-2 ">Avance: </Label>
                                            <Label className="floatleft ml-2 bcolorr">{"0%"}</Label>
                                            <Label className="floatleft ml-2 bcolorbb ">{"<=25%"}</Label>
                                            <Label className="floatleft ml-2 bcolorlb">{">25% <=50%"}</Label>
                                            <Label className="floatleft ml-2 bcolorbg">{">50% <100%"}</Label>
                                            <Label className="floatleft ml-2 bcolordb">{">=100%"}</Label>
                                            <Label className="floatleft ml-2 bg-morado">{"Sin planificar"}</Label>
                                        </>)}
                                    <Table className=" mb-2 scroll " >
                                        <Thead class="thead-secondary">
                                            <Tr>
                                                {encabezadoTabla.map((etiqueta, index) => (
                                                    <Th >{etiqueta}</Th>
                                                ))}
                                            </Tr>
                                        </Thead>
                                        <Tbody>{datosTabla.map((dato, i) => (
                                            <Tr class={(i % 2) !== 0 ? "table-active" : ""} >
                                                {Object.entries(dato).map(([key, value]) => (
                                                    <Td className={"text-center"} >{value}</Td>
                                                ))}
                                            </Tr>
                                        ))}
                                        </Tbody>
                                    </Table>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 mt-2  ">
                                    {Piedetabla ? Piedetabla : ""}
                                </div>

                            </div>
                        )
                    }
                    {datosgraficapie.labels && (
                        <div className={datosgraficapie.labels.length > 6 ? "col-lg-6 col-md-6 col-sm-12 col-xs-12  height390px" :
                            "col-lg-6 col-md-6 col-sm-12 col-xs-12  height350px"
                        } >
                            <Pie data={datosgraficapie} options={opciones} />
                        </div>
                    )}
                    {/* Tabla a la derecha o izquierda de la gráfica */
                        tablaizquierda === false && (
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 margintop20px" >
                                <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                                    {tablaTipo === "SeguimientoPintado" && (
                                        <>
                                            <Label className="floatleft ml-2 ">Avance: </Label>
                                            <Label className="floatleft ml-2 bcolorr">{"0%"}</Label>
                                            <Label className="floatleft ml-2 bcolorbb ">{"<=25%"}</Label>
                                            <Label className="floatleft ml-2 bcolorlb">{">25% <=50%"}</Label>
                                            <Label className="floatleft ml-2 bcolorbg">{">50% <100%"}</Label>
                                            <Label className="floatleft ml-2 bcolordb">{">=100%"}</Label>
                                            <Label className="floatleft ml-2 bg-morado">{"Sin planificar"}</Label>
                                        </>)}
                                    <Table className=" mb-2 scroll " >
                                        <Thead class="thead-secondary">
                                            <Tr>
                                                {encabezadoTabla.map((etiqueta, index) => (
                                                    <Th >{etiqueta}</Th>
                                                ))}
                                            </Tr>
                                        </Thead>
                                        <Tbody>{datosTabla.map((dato, i) => (
                                            <Tr class={(i % 2) !== 0 ? "table-active" : ""} >
                                                {Object.entries(dato).map(([key, value]) => (
                                                    <Td className={"text-center"} >{value}</Td>
                                                ))}
                                            </Tr>
                                        ))}
                                        </Tbody>
                                    </Table>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 mt-2  ">
                                    {Piedetabla ? Piedetabla : ""}
                                </div>

                            </div>
                        )
                    }
                </Row>
            )}

        </Fragment>

    )
};



export default Graficapietabla;